import { useContent } from '@/hooks/useContent';
import { Container, WwProse } from '@/components';
import { useEffect } from 'react';

function createSlug(str: string) {
  return String(str)
    .normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
}

export const FaqPage = () => {
  const { faqs } = useContent();

  useEffect(() => {
    if (!faqs.length) return;
    const hash = window.location.hash;
    if (hash) {
      const element = document.getElementById(hash.slice(1));
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [faqs]);

  return (
    <Container max={820}>
      <div className="ww-eyebrow" style={{ color: 'var(--ww-orange)' }}>
        Häufige Fragen
      </div>
      <h1 className="mb-8 mt-2 font-disp text-5xl uppercase text-ww-charcoal sm:text-6xl">FAQ</h1>

      <div className="flex w-full flex-col gap-10">
        {faqs.map((faq, index) => {
          const slug = createSlug(faq.q);
          return (
            <div key={index}>
              <a href={`#${slug}`} className="no-underline">
                <h2
                  id={slug}
                  className="scroll-mt-24 pb-2 font-sans text-xl font-bold text-ww-charcoal"
                  style={{ borderBottom: '3px solid var(--ww-charcoal)' }}>
                  {faq.q}
                </h2>
              </a>
              <WwProse html={faq.a} className="mt-3" />
            </div>
          );
        })}
      </div>
    </Container>
  );
};
